import { PageSaveState, State } from "../state";

export interface SavePageAction {
  completed: boolean;
  failed: boolean;
  page: number;
  type: "SAVE PAGE";
}

export const savePage = (state: State, action: SavePageAction): State => {
  if (state.pages[action.page].pageSaveState === PageSaveState.Clean) {
    return state;
  }
  if (!action.failed) {
    return {
      ...state,
      pages: [
        ...state.pages.slice(0, action.page),
        {
          ...state.pages[action.page],
          activeZones: [],
          pageSaveState: action.completed ? PageSaveState.Clean : PageSaveState.Saving,
        },
        ...state.pages.slice(action.page + 1),
      ],
    };
  }
  return {
    ...state,
    pages: [
      ...state.pages.slice(0, action.page),
      {
        ...state.pages[action.page],
        activeZones: [],
        pageSaveState: PageSaveState.Dirty,
      },
      ...state.pages.slice(action.page + 1),
    ],
  };
};
